import React, { Component } from 'react';
import {
  Button,
  NavLink,
  Nav,
  Navbar,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import OrderViewer from './orderviewer';
import { withRouter } from 'react-router-dom';
import { savePageOrder } from '../../api/legacy';
import queryString from 'query-string';
import { authenticateLegacy } from '../../api/authentication';
import {
  authenticate,
  getDocumentArrayBuffer,
  deletePage
} from '../../api/legacy';
import { loadAnnotations, saveAnnotations } from '../../api/annotation';
import * as pdfjs from 'pdfjs-dist';
import Thumbnail from './thumbnail';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

export class PageOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelected: undefined,
      dropdownOpen: false,
      canvasUrls: {},
      finishedDrawing: false
    };
    this.selectPage = this.selectPage.bind(this);
    this.changePageOrder = this.changePageOrder.bind(this);
    this.savePageOrder = this.savePageOrder.bind(this);
    this.internalDeletePage = this.internalDeletePage.bind(this);
    this.actualDeletePage = this.actualDeletePage.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleMovePageModal = this.toggleMovePageModal.bind(this);
    this.selectMoveTo = this.selectMoveTo.bind(this);
    this.movePage = this.movePage.bind(this);
    this.doneDrawing = this.doneDrawing.bind(this);
    this.updateIndex = this.updateIndex.bind(this);

    this.canvasRef = React.createRef();
  }

  async componentDidMount() {
    pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;

    let pdfContent = null;
    let tmpAnnotations = null;
    let annotations = null;
    try {
      if (process.env.NODE_ENV !== 'development') {
        await authenticate(client, documentId, applicationSessionId, sessionId);
      }
      if (process.env.NODE_ENV !== 'development') {
        console.log('In production');
        pdfContent = await getDocumentArrayBuffer(
          client,
          documentId,
          applicationSessionId,
          sessionId
        );
      }
      if (process.env.NODE_ENV === 'development') {
        console.log('In dev using local pdf.');
        pdfContent = '/test/test.largecolor.pdf';
      }

      let pageIndexObject = [];

      const response = await authenticateLegacy(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );

      const token = response.token;

      tmpAnnotations = await loadAnnotations(token, client, documentId);

      if (
        tmpAnnotations !== null &&
        tmpAnnotations.instantJson &&
        tmpAnnotations.instantJson.annotationJSON
      ) {
        annotations = tmpAnnotations.instantJson.annotationJSON;
        if (annotations.pdfId) {
          annotations.pdfId = null;
        }
      }

      let thumbnails = {};
      await pdfjs.getDocument(pdfContent).promise.then(pdf => {
        let pageCount = pdf.numPages;
        for (let i = 1; i <= pageCount; i++) {
          pageIndexObject.push(i);
        }
        pageIndexObject.map(async (item, index) => {
          await pdf.getPage(item).then(page => {
            thumbnails[item] = (
              <Thumbnail
                page={page}
                item={item}
                doneDrawing={this.doneDrawing}
              />
            );
            if (index === pageCount - 1) {
              this.setState({
                thumbnails,
                pageIndexObject
              });
            }
          });
        });
      });

      this.setState((state, props) => {
        return {
          finishedLoading: true,
          pdfContent,
          client,
          documentId,
          thumbnails,
          applicationSessionId,
          sessionId,
          annotations,
          token
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  selectPage(key) {
    this.setState({
      currentSelected: key
    });
  }

  changePageOrder(item, newIndex) {
    let { pageIndexObject } = this.state;
    let oldIndex;

    pageIndexObject.map((listItem, index) => {
      if (item === listItem) {
        oldIndex = index;
      }
      return true;
    });

    if (
      newIndex >= 0 &&
      newIndex <= pageIndexObject.length &&
      newIndex !== oldIndex
    ) {
      pageIndexObject.splice(
        newIndex,
        0,
        pageIndexObject.splice(oldIndex, 1)[0]
      );
    }

    this.setState({
      pageIndexObject
    });
  }

  async savePageOrder() {
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    const { pageIndexObject } = this.state;
    let { annotations } = this.state;
    let toReturn = [];
    let newAnnotations = undefined;
    if (annotations && annotations.annotations) {
      newAnnotations = [...annotations.annotations];
    }
    pageIndexObject.map((item, index) => {
      const oldIndex = parseInt(item) - 1;
      toReturn.push({ oldIndex, index });
      return true;
    });

    if (newAnnotations) {
      Object.keys(annotations.annotations).map(key => {
        let annotation = newAnnotations[key];
        let newPageIndex = annotation.pageIndex;
        pageIndexObject.map((item, index) => {
          const oldIndex = parseInt(item) - 1;
          if (oldIndex !== index && annotation.pageIndex === oldIndex) {
            newPageIndex = index;
          }
          return true;
        });
        annotation.pageIndex = newPageIndex;
        return true;
      });
    }
    if (newAnnotations && newAnnotations.length > 0) {
      annotations.annotations = newAnnotations;
      await saveAnnotations(
        this.state.token,
        this.state.client,
        this.state.documentId,
        annotations
      );
    }
    await savePageOrder(
      this.state.client,
      this.state.documentId,
      toReturn,
      applicationSessionId,
      sessionId
    );
    this.props.history.push(
      `/legacy/${this.state.client}/${this.state.documentId}?appSessionId=${
        this.state.applicationSessionId
      }&sessionId=${this.state.sessionId}`
    );
  }

  toggleMovePageModal() {
    if (this.state.movePageModal) {
      this.setState({
        movePageModal: false
      });
    } else {
      this.setState({
        movePageModal: true
      });
    }
  }

  toggleDropdown() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  selectMoveTo(index) {
    console.log(index);
    this.setState({
      moveToPage: index
    });
  }

  movePage() {
    if (this.state.moveToPage || this.state.moveToPage === 0) {
      this.changePageOrder(this.state.currentSelected, this.state.moveToPage);
      this.setState({
        movePageModal: false,
        moveToPage: undefined,
        movePageError: undefined
      });
    } else {
      this.setState({
        movePageError: 'Please select a destination.'
      });
    }
  }

  updateIndex = (dragIndex, hoverIndex) => {
    let { pageIndexObject } = this.state;
    const item = pageIndexObject[dragIndex];
    pageIndexObject.splice(
      hoverIndex,
      0,
      pageIndexObject.splice(dragIndex, 1)[0]
    );
    this.setState({
      pageIndexObject,
      currentSelected: item
    });
  };

  internalDeletePage() {
    // if agreed
    this.setState({
      showDeleteModal: true,
      finishedLoading: false,
      deletePageNum: this.state.currentSelected
    });
  }

  async actualDeletePage() {
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    console.log(`Going to actually delete page ${this.state.deletePageNum}`);
    this.setState({
      finishedDrawing: false,
      canvasUrls: {},
      thumbnails: {},
      pageIndexObject: []
    });
    await deletePage(
      client,
      documentId,
      this.state.deletePageNum,
      applicationSessionId,
      sessionId
    );

    // on success load the pdf again
    let pdfContent = null;
    if (process.env.NODE_ENV !== 'development') {
      console.log('In production');
      pdfContent = await getDocumentArrayBuffer(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      pdfContent = '/test/test.pdf';
    }

    let thumbnails = {};
    let pageIndexObject = [];
    await pdfjs.getDocument(pdfContent).promise.then(pdf => {
      let pageCount = pdf.numPages;
      for (let i = 1; i <= pageCount; i++) {
        pageIndexObject.push(i);
      }
      pageIndexObject.map(async (item, index) => {
        await pdf.getPage(item).then(page => {
          thumbnails[item] = (
            <Thumbnail page={page} item={item} doneDrawing={this.doneDrawing} />
          );
          if (index === pageCount - 1) {
            this.setState({
              thumbnails,
              pageIndexObject
            });
          }
        });
      });
    });

    this.setState({
      deletePageNum: '',
      pdfContent,
      showDeleteModal: false,
      finishedLoading: true,
      currentSelected: ''
    });
  }

  doneDrawing(item) {
    let { canvasUrls, pageIndexObject } = this.state;
    let canvas = document.getElementById(`canvas_${item}`);
    let preview = '';
    if (canvas && canvas !== null) {
      preview = canvas.toDataURL('image/png');
    }
    canvasUrls[item] = preview;
    let finishedDrawing = false;
    if (Object.keys(canvasUrls).length === pageIndexObject.length) {
      finishedDrawing = true;
    }
    this.setState({
      canvasUrls,
      finishedDrawing
    });
  }

  async toggleDeleteModal() {
    const client = this.props.match.params.client;
    const documentId = this.props.match.params.superid;
    const parsed = queryString.parse(this.props.location.search);
    const applicationSessionId = parsed.appSessionId;
    const sessionId = parsed.sessionId;
    let pdfContent = null;
    if (process.env.NODE_ENV !== 'development') {
      console.log('In production');
      pdfContent = await getDocumentArrayBuffer(
        client,
        documentId,
        applicationSessionId,
        sessionId
      );
    }
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      pdfContent = '/test/test.pdf';
    }
    this.setState(prevState => ({
      showDeleteModal: !prevState.showDeleteModal,
      finishedLoading: true,
      pdfContent
    }));
  }

  render() {
    const { currentSelected, pageIndexObject } = this.state;
    return (
      <div className="App">
        <div
          style={{
            width: '100%',
            background: '#3d464d',
            height: '48px',
            position: 'fixed',
            zIndex: 11
          }}
        >
          <Navbar
            color="faded"
            light
            className="topNav"
            style={{ padding: 0, height: '48px', margin: 0 }}
          >
            <div className="navbar-brand mr-auto">
              <NavLink
                href={`/legacy/${this.state.client}/${
                  this.state.documentId
                }?appSessionId=${this.state.applicationSessionId}&sessionId=${
                  this.state.sessionId
                }`}
                className="topNavLink"
                style={{ color: '#ffffff' }}
              >
                Back To Viewer
              </NavLink>
            </div>
            <Nav navbar className="align-top">
              <li className="nav-item">
                <div style={{ marginBottom: '2px' }}>
                  {this.state.currentSelected &&
                    this.state.currentSelected !== '' &&
                    this.state.currentSelected &&
                    this.state.currentSelected !== '' && (
                      <Button
                        color="warning"
                        style={{ marginRight: '15px' }}
                        onClick={() => this.toggleMovePageModal()}
                      >
                        <img
                          style={{ height: '15px', display: 'inline-block' }}
                          alt="Move page"
                          src="data:image/svg+xml;base64, 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"
                        />
                      </Button>
                    )}
                  {this.state.currentSelected &&
                    this.state.currentSelected !== '' &&
                    this.state.currentSelected &&
                    this.state.currentSelected !== '' && (
                      <Button
                        color="danger"
                        onClick={() => this.internalDeletePage()}
                      >
                        <img
                          style={{ height: '15px', display: 'inline-block' }}
                          alt="Delete page"
                          src="data:image/png;base64,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"
                        />
                      </Button>
                    )}
                  <ButtonGroup
                    style={{ marginRight: '15px', padding: '0.5rem 1rem' }}
                  >
                    {this.state.currentSelected &&
                      this.state.currentSelected !== '' &&
                      this.state.currentSelected &&
                      this.state.currentSelected !== '' && (
                        <>
                          <Button
                            color="primary"
                            onClick={() =>
                              this.changePageOrder(
                                currentSelected,
                                pageIndexObject.indexOf(currentSelected) - 1
                              )
                            }
                          >
                            <img
                              style={{ height: '15px' }}
                              alt="backwards"
                              src="data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDc3LjE3NSA0NzcuMTc1IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzcuMTc1IDQ3Ny4xNzU7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgY2xhc3M9IiI+PGc+PGc+Cgk8cGF0aCBkPSJNMTQ1LjE4OCwyMzguNTc1bDIxNS41LTIxNS41YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xcy0xMy44LTUuMy0xOS4xLDBsLTIyNS4xLDIyNS4xYy01LjMsNS4zLTUuMywxMy44LDAsMTkuMWwyMjUuMSwyMjUgICBjMi42LDIuNiw2LjEsNCw5LjUsNHM2LjktMS4zLDkuNS00YzUuMy01LjMsNS4zLTEzLjgsMC0xOS4xTDE0NS4xODgsMjM4LjU3NXoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0ZGRkZGRiIgZGF0YS1vbGRfY29sb3I9IiNmZmZmZmYiPjwvcGF0aD4KPC9nPjwvZz4gPC9zdmc+"
                            />
                          </Button>
                          <Button
                            color="primary"
                            onClick={() =>
                              this.changePageOrder(
                                currentSelected,
                                pageIndexObject.indexOf(currentSelected) + 1
                              )
                            }
                          >
                            <img
                              style={{ height: '15px' }}
                              alt="fowards"
                              src="data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDc3LjE3NSA0NzcuMTc1IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NzcuMTc1IDQ3Ny4xNzU7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgY2xhc3M9IiI+PGc+PGc+Cgk8cGF0aCBkPSJNMzYwLjczMSwyMjkuMDc1bC0yMjUuMS0yMjUuMWMtNS4zLTUuMy0xMy44LTUuMy0xOS4xLDBzLTUuMywxMy44LDAsMTkuMWwyMTUuNSwyMTUuNWwtMjE1LjUsMjE1LjUgICBjLTUuMyw1LjMtNS4zLDEzLjgsMCwxOS4xYzIuNiwyLjYsNi4xLDQsOS41LDRjMy40LDAsNi45LTEuMyw5LjUtNGwyMjUuMS0yMjUuMUMzNjUuOTMxLDI0Mi44NzUsMzY1LjkzMSwyMzQuMjc1LDM2MC43MzEsMjI5LjA3NXogICAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0ZGRkZGRiIgZGF0YS1vbGRfY29sb3I9IiNmZmZmZmYiPjwvcGF0aD4KPC9nPjwvZz4gPC9zdmc+"
                            />
                          </Button>
                        </>
                      )}
                    <Button
                      color="success"
                      onClick={() => this.savePageOrder()}
                    >
                      {'Save'}
                    </Button>
                  </ButtonGroup>
                </div>
              </li>
            </Nav>
          </Navbar>
        </div>
        {this.state.pageIndexObject && (
          <DragDropContextProvider backend={HTML5Backend}>
            <OrderViewer
              pageIndexObject={this.state.pageIndexObject}
              selectPage={this.selectPage}
              currentSelected={this.state.currentSelected}
              changePageOrder={this.changePageOrder}
              pdfContent={this.state.pdfContent}
              thumbnails={this.state.thumbnails}
              updateIndex={this.updateIndex}
              canvasUrls={this.state.canvasUrls}
              finishedDrawing={this.state.finishedDrawing}
            />
          </DragDropContextProvider>
        )}
        <Modal
          fade={false}
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
        >
          <ModalHeader toggle={this.toggleDeleteModal}>Delete Page</ModalHeader>
          <ModalBody>
            Are you sure you want to delete this page? This action cannot be
            undone.
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.actualDeletePage}>
              Delete Page
            </Button>{' '}
            <Button color="secondary" onClick={this.toggleDeleteModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          fade={false}
          isOpen={this.state.movePageModal}
          toggle={this.toggleMovePageModal}
        >
          <ModalHeader toggle={this.toggleMovePageModal}>Move Page</ModalHeader>
          <ModalBody>
            New Page Index:
            <Dropdown
              isOpen={this.state.dropdownOpen}
              toggle={this.toggleDropdown}
              style={{ display: 'inline-block', marginLeft: '10px' }}
            >
              <DropdownToggle caret>
                {this.state.moveToPage || this.state.moveToPage === 0
                  ? this.state.moveToPage + 1
                  : 'select'}
              </DropdownToggle>
              {pageIndexObject && (
                <DropdownMenu>
                  {pageIndexObject.map((item, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => this.selectMoveTo(index)}
                      >
                        {index + 1}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              )}
            </Dropdown>
            {this.state.movePageError && (
              <div style={{ color: 'red' }}>{this.state.movePageError}</div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="warning" onClick={this.movePage}>
              Move Page
            </Button>{' '}
            <Button color="secondary" onClick={this.toggleMovePageModal}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default withRouter(PageOrder);
